import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Логотип"
}, null, -1)

import { computed, ref } from 'vue'
import {
  User,
  UserPermissions,
  BGOperationsService,
  UpdateDownloadService,
  APP_META,
  ConnectionStatus,
  ToolsService,
  Role,
} from '@prodcard/core'
import {
  VNavigation,
  NavigationItem,
  prepareNavLinks,
  VBgOperationsVue,
  VUpdateApplyVue,
  VImportExportNoticeVue,
} from '../components'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseWebLayout',
  props: {
    currentUser: {},
    currentRole: {},
    permissions: {},
    isDarkTheme: { type: Boolean },
    links: {},
    bgOperationsService: {},
    toolsService: {},
    updateDownloadService: {},
    connectionStatus: {},
    enableAdditionalLogin: { type: Boolean }
  },
  emits: ["toggleTheme", "logout", "login"],
  setup(__props: any) {

const props = __props;





const drawer = ref(true)

const permittedLinks = computed(() => {
  return prepareNavLinks(props.links, props.permissions)
})

const connectionInfo = computed(() => {
  if (!props.connectionStatus) return undefined
  switch (props.connectionStatus) {
    case ConnectionStatus.ONLINE:
      return { icon: 'mdi-wifi', hint: 'Есть связь с сервером' }
    case ConnectionStatus.OFFLINE:
      return { icon: 'mdi-wifi-off', hint: 'Связь с сервером отсутствует' }
  }
  return undefined
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      elevation: "0",
      border: ""
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createElementVNode("h2", {
          class: "d-none d-lg-inline ml-1",
          style: _normalizeStyle({ color: _ctx.isDarkTheme ? 'white' : 'black' })
        }, _toDisplayString(_unref(APP_META).productTitle), 5),
        _createVNode(_component_v_app_bar_nav_icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value)),
          class: "ml-1 d-lg-none"
        })
      ]),
      append: _withCtx(() => [
        (_ctx.toolsService)
          ? (_openBlock(), _createBlock(_unref(VImportExportNoticeVue), {
              key: 0,
              "tools-service": _ctx.toolsService
            }, null, 8, ["tools-service"]))
          : _createCommentVNode("", true),
        (_ctx.updateDownloadService)
          ? (_openBlock(), _createBlock(_unref(VUpdateApplyVue), {
              key: 1,
              "update-download-service": _ctx.updateDownloadService
            }, null, 8, ["update-download-service"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(VBgOperationsVue), { "bg-operations-service": _ctx.bgOperationsService }, null, 8, ["bg-operations-service"]),
        (connectionInfo.value !== undefined)
          ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 2,
              text: connectionInfo.value.hint
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  variant: "text",
                  icon: connectionInfo.value.icon,
                  to: "/app-settings",
                  active: false
                }), null, 16, ["icon"])
              ]),
              _: 1
            }, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          variant: "text",
          icon: _ctx.isDarkTheme ? 'mdi-weather-night' : 'mdi-weather-sunny',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleTheme', !_ctx.isDarkTheme)))
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(_unref(VNavigation), {
      "state-drawer": drawer.value,
      "onUpdate:stateDrawer": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
      "current-user": _ctx.currentUser,
      "current-role": _ctx.currentRole,
      links: permittedLinks.value,
      "enable-additional-login": _ctx.enableAdditionalLogin,
      onLogout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('logout'))),
      onLogin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('login')))
    }, null, 8, ["state-drawer", "current-user", "current-role", "links", "enable-additional-login"]),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          class: "pa-8",
          fluid: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_router_view, {
              key: _ctx.$route?.fullPath
            }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})